import React, { useEffect, useState } from "react";
import { Fade, Grow, makeStyles } from "@material-ui/core";
import { Link } from 'react-router-dom';


let useStyles = makeStyles((theme) => ({
    bgSubmenu: {
        display: "flex",
        justifyContent: "space-between",
        alignItem: "flex-start",
        minWidth: 200,
        minHeight: 200,
        padding: 15,
        position: "relative",
        top: 10,
        borderRadius: 10,
        backgroundColor: " #fff",
        // borderTop: "2px solid #DA212E",
        // boxShadow: "0 3px 12px rgba(0,0,0,.1)",
        boxShadow: "0px 4px 11px 0px rgba(0, 0, 0, 0.15)",

    },
    gridSubmenu: {
        // display: "flex",
        // justifyContent: "center",
        // alignItem: "center",
        position: "absolute",
        zIndex: 100,
        // minWidth: 484,
        minHeight: 200,
        padding: "20px 20px 20px 0px ",
        transition: "all 0.3s linear", /* vendorless fallback */


    },
    subMenu: {
        '& > li': {
            padding: "7px 7px",
            margin: "2px 2px",
            fontWeight: "bold",
            '& > a': {
                whiteSpace: 'nowrap'
            },
        },
    },
    titleSubmenu: {
        // borderBottom: "1px solid #dbd9d9",
        fontSize: 14,
        color: 'rgba(0,0,0,0.4)',
        fontWeight: '300 !important',
        marginBottom: "10px !important",

    },
    descSubMenu: {
        '& a': {
            width: "100%",
            color: "black",
            cursor: "pointer",
            padding: "1px 4px",
            fontSize: ".825rem",
            borderRadius: " 4px",
            fontWeight: 400,
            fontSize: 14,
            whiteSpace: "nowrap",
            textDecoration: "none",
            display: "inline-block",
        },
        '&:hover': {
            // backgroundColor: "#f2f2f2",
            color: '#E60001 !important'

        },
    },
    badge: {
        background: "#DDE0FF",
        display: 'inline-block',
        padding: "5px 10px ",
        borderRadius: 20,
        fontSize: 10,
        marginLeft: 5,
        color: '#5A68B2'
    },
    title: {
        color: 'black',
        fontWeight: 400,
        fontSize: 14,
        '&:hover': {
            // backgroundColor: "#f2f2f2",
            color: '#E60001 !important'

        },

    },
    animationList: {
        "-webkit-animation": ` slidein 1s ease`,
        "-moz-animation": ` slidein 1s ease`,
        "-o-animation": ` slidein 1s ease`,
        animation: ` slidein 1s ease`,
    }
}))

export default function Index({ item, flagHeader, ind, home, IndexMenu }) {

    let classes = useStyles();


    return (
        <>
            {
                <ul >
                    <li key={ind} style={{ zIndex: 5 }}>
                        <p to={item.route} className={`m-0 titleRed ${classes['title']}`} style={{ color: home ? "white" : flagHeader ? 'white' : '' }}>
                            {item.label}
                        </p>
                        <div className={`${classes['gridSubmenu']} ${classes['animationList']}`} >
                            <div className={classes['bgSubmenu']}>
                                <>
                                    {
                                        item.child.map((item, ind) => (
                                            <ul className={classes['subMenu']}>
                                                {
                                                    item.label && (
                                                        <li key={ind} style={{ zIndex: 5 }} className={`${classes['titleSubmenu']}`}>
                                                            {item.label}
                                                        </li>
                                                    )
                                                }

                                                {
                                                    item.child.map((item, ind) => (
                                                        <li key={ind} style={{ zIndex: 5 }} className={classes['descSubMenu']}>
                                                            {
                                                                item.route.slice(0, 4) === "http" ?
                                                                    <a target="_blank" href={item.route} >
                                                                        {item.label}
                                                                        {
                                                                            item?.badge?.title && (
                                                                                <span className={classes['badge']}>
                                                                                    {item?.badge?.title}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    </a>
                                                                    :
                                                                    item?.action
                                                                        ? (
                                                                            <span  className={`${classes['title']}`} onClick={()=> item?.action()} style={{cursor:'pointer'}}>
                                                                                {item.label}
                                                                            </span>
                                                                        )
                                                                        :
                                                                        <Link to={item.route} >
                                                                            {item.label}
                                                                            {
                                                                                item?.badge?.title && (
                                                                                    <span className={classes['badge']}>
                                                                                        {item?.badge?.title}
                                                                                    </span>
                                                                                )
                                                                            }
                                                                        </Link>
                                                            }
                                                        </li>
                                                    ))
                                                }

                                            </ul>
                                        ))
                                    }
                                </>
                            </div>
                        </div>
                    </li>
                </ul>
            }


        </>
    )
}
